import './ShareWindow.css';
import React, { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import ShareModal from './component/ShareModal';
import { Button } from 'primereact/button';

function ShareWindow(props) {
  const { t } = useTranslation();
  const [active, setActive] = useState(false);
  const btnRef = useRef(null);

  return (
    <div id="ShareWindow" className="ShareWindow">
      <Button
        className="HorizontalButton"
        type="button"
        alt={t('share.tooltip') || 'Compartilhar'}
        title={t('share.tooltip') || 'Compartilhar'}
        onClick={() => setActive(true)}
        ref={btnRef}
        icon="pi pi-share-alt"
      >
 
      </Button>

      <ShareModal map={props.map} active={active} callback={setActive} />
    </div>
  );
}

export default ShareWindow;
